import React from 'react';
import Button from '../Button';
import { DayObject } from './ValidInputDate.utils';

type CalendarPopupProps = {
    displayMonth: Date;
    onPrevMonth: () => void;
    onNextMonth: () => void;
    canGoPrev: boolean;
    canGoNext: boolean;
    calendarWeeks: DayObject[][];
    onDayClick: (dayObj: DayObject) => void;
};

const CalendarPopup: React.FC<CalendarPopupProps> = ({
    displayMonth,
    onPrevMonth,
    onNextMonth,
    canGoPrev,
    canGoNext,
    calendarWeeks,
    onDayClick,
}) => (
    <div
        className="valid-input-date-calendar"
        role="dialog"
        aria-label="Date picker calendar"
    >
        <div className="calendar-header">
            <Button
                id="nav-btn-prev"
                cssName={`nav-button prev btn-alt ${!canGoPrev ? 'disabled' : ''}`}
                onClick={onPrevMonth}
                disabled={!canGoPrev}
                aria-label="Previous month"
            >
                &#10094;
            </Button>

            <h2 className="month-year">{displayMonth.toLocaleString('default', { month: 'long', year: 'numeric' })}</h2>

            <Button
                id="nav-btn-next"
                cssName={`nav-button next btn-alt ${!canGoNext ? 'disabled' : ''}`}
                onClick={onNextMonth}
                disabled={!canGoNext}
                aria-label="Next month"
            >
                &#10095;
            </Button>
        </div>

        <div className="calendar-grid">
            <div className="day-headers">
                {['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'].map(day => (
                    <div
                        key={day}
                        className="day-header"
                    >
                        {day}
                    </div>
                ))}
            </div>
            {calendarWeeks.map((week, weekIdx) => (
                <div
                    key={weekIdx}
                    className="week"
                >
                    {week.map((dayObj, dayIdx) => (
                        <button
                            key={dayIdx}
                            type="button"
                            className={`day ${!dayObj.isCurrentMonth ? 'other-month' : ''} ${dayObj.isToday ? 'today' : ''} ${dayObj.isSelected ? 'selected' : ''} ${dayObj.isDisabled ? 'disabled' : ''}`}
                            onClick={() => onDayClick(dayObj)}
                            disabled={dayObj.isDisabled}
                            aria-label={`${dayObj.dayOfMonth}${dayObj.isToday ? ', today' : ''}${dayObj.isSelected ? ', selected' : ''}`}
                            aria-disabled={dayObj.isDisabled}
                        >
                            {dayObj.dayOfMonth}
                        </button>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default CalendarPopup;
